<template>
    <div class="user-read-dialog">
        <el-dialog
            v-model="visible"
            :title="type === ARTICLE_TYPE.USER_AGREEMENT.code ? '用户协议' : '隐私政策'"
            width="800"
            :close-on-click-modal="false"
        >
            <div class="content">
                <div v-html="content"></div>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button type="primary" @click="onClose" :color="theme.themeColor"> 我已阅读 </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script lang="ts" setup>
import { ElDialog, ElButton } from "element-plus";
import { ARTICLE_TYPE } from "@supplier/meta";
import { theme } from "@/config/sassTheme.ts";
import { articleService } from "@/api/services/articleService";
import { customerArticleService } from "@/api/services/customerArticleService.ts";
import { editorManage } from "@/utils/editorManage.ts";
import { Article } from "@supplier/entity";
import { ref, onMounted, watch } from "vue";
import { SYSTEM_LOGIN_TYPE } from "../../type.ts";

const props = defineProps<{
    type: number;
    systemType: number;
}>();

const visible = defineModel<boolean>("visible");
const content = ref<string | undefined>();

const article = ref<Article>();
const getArticle = async () => {
    if (props.systemType === SYSTEM_LOGIN_TYPE.ADMIN) {
        article.value = await articleService.find({ type: props.type, app: props.systemType });
    } else {
        article.value = await customerArticleService.findArticle({ type: props.type, app: props.systemType });
    }
    await setContent();
};

const setContent = async () => {
    content.value = editorManage.handleContentWidth(await editorManage.getRealContent(article.value?.content ?? ""));
};

onMounted(() => {
    if (props.systemType) getArticle();
});
watch(
    () => props.systemType,
    () => {
        getArticle();
    }
);

const onClose = () => {
    visible.value = false;
};
</script>

<style lang="scss" scoped>
.user-read-dialog {
    :deep .el-dialog {
        padding: 0 !important;
        border-radius: 6px;

        .el-dialog__header {
            padding: 16px;
            font-size: 16px;
            color: #000000e0;
            font-weight: 600;
            border-bottom: 1px #d9d9d9 solid;

            .el-dialog__headerbtn:focus .el-dialog__close,
            .el-dialog__headerbtn:hover .el-dialog__close {
                color: #000000e0;
            }
        }

        .el-dialog__body {
            padding-top: 20px;
            height: 431px;
            overflow-y: auto;
        }

        .content {
            padding: 0 20px;
        }

        .el-dialog__footer {
            padding: 40px 20px 20px 20px;
        }
    }
}
</style>
